import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import SocialSharingWeb from 'routes/articleshow_v2/components/desktop/SocialSharingWeb';
import s from './NewStoryCard.scss';

function ShareComponent({ title, wu }) {
  const [showSharing, setShowSharing] = useState(false);

  return (
    <div className={s.fromToiWrap}>
      <span>From TOI Print Edition</span>
      <div
        className={`${s.timelineshare} icon_share_wrap`}
        onMouseEnter={() => setShowSharing(!showSharing)}
        onMouseLeave={() => setShowSharing(!showSharing)}
      >
        <div className={s.shareIconWrap}>
          <span className={s.shareIcon} />
          {showSharing && (
            <div className={`${s.shareWrap}`}>
              <ErrorBoundary>
                <SocialSharingWeb
                  title={title}
                  textRequired={false}
                  url={wu || ''}
                  disableShortUrl
                  linkeDin
                  via="@timesofindia"
                  topsticky
                  defaultEmailView
                />
              </ErrorBoundary>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

ShareComponent.propTypes = {
  title: PropTypes.string.isRequired,
  wu: PropTypes.string,
};

ShareComponent.defaultProps = {
  wu: '',
};

export default ShareComponent;
